'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getReviewData = getReviewData;
exports.postReview = postReview;
exports.setPostReview = setPostReview;
exports.getFormChoicesConfig = getFormChoicesConfig;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/review/LOAD';
var LOAD_SUCCESS = 'redux-frontend/review/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/review/LOAD_FAIL';

var POST_REVIEW = 'redux-frontend/review/POST';
var POST_REVIEW_SUCCESS = 'redux-frontend/review/POST_SUCCESS';
var POST_REVIEW_FAIL = 'redux-frontend/review/POST_FAIL';

var GET_FORM_CHOICES_CONFIG = 'redux-frontend/review/GET_FORM_CHOICES_CONFIG';
var GET_FORM_CHOICES_CONFIG_SUCCESS = 'redux-frontend/review/GET_FORM_CHOICES_CONFIG_SUCCESS';
var GET_FORM_CHOICES_CONFIG_FAIL = 'redux-frontend/review/GET_FORM_CHOICES_CONFIG_FAIL';

var SET_POST_REVIEW = 'redux-frontend/review/SET_POST_REVIEW';

var initialState = {
  loaded: false,
  reviewing: false,
  postReview: {
    title: '',
    text: ''
  },
  formChoicesConfig: [] // [{ key: String, values: [{ key: String, label: String }] }]
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        data: action.result,
        loading: false,
        loaded: true
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false
      });
    case POST_REVIEW:
      return (0, _extends3.default)({}, state, {
        reviewing: true
      });
    case POST_REVIEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        reviewing: false
      });
    case POST_REVIEW_FAIL:
      return (0, _extends3.default)({}, state, {
        reviewing: false
      });
    case SET_POST_REVIEW:
      return (0, _extends3.default)({}, state, {
        postReview: action.data
      });
    case GET_FORM_CHOICES_CONFIG_SUCCESS:
      return (0, _extends3.default)({}, state, {
        formChoicesConfig: action.result.choicesForReviewForm
      });
    default:
      return state;
  }
}

function getReviewData(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/reviews/' + id);
    }
  };
}

function postReview(id, data) {
  return {
    types: [POST_REVIEW, POST_REVIEW_SUCCESS, POST_REVIEW_FAIL],
    promise: function promise(client) {
      return client.post('/reviews/' + id, { data: data });
    }
  };
}

function setPostReview(data) {
  return {
    type: SET_POST_REVIEW,
    data: data
  };
}

function getFormChoicesConfig() {
  return {
    types: [GET_FORM_CHOICES_CONFIG, GET_FORM_CHOICES_CONFIG_SUCCESS, GET_FORM_CHOICES_CONFIG_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=choicesForReviewForm');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/review.js
// module id = 480
// module chunks = 47